// Replace modal texts
export const SL_LIST_MANAGEMENT_REPLACE_MODAL_DETAILS_TEXT = "si.management.sl.listManagement.modal.replace.details";
export const SL_LIST_MANAGEMENT_REPLACE_MODAL_TITLE_TEXT = "si.management.sl.listManagement.modal.replace.title";
export const SL_LIST_MANAGEMENT_REPLACE_MODAL_BTN_CONFIRM_TEXT = "si.common.button.continue";

// SF Terms Modal
export const MANAGEMENT_SF_TERMS_MODAL_TITLE = "si.management.sf.terms.modal.title";
export const MANAGEMENT_SF_TERMS_MODAL_DETAILS = "si.management.sf.terms.modal.details";

// Delete modal texts
export const SL_LIST_MANAGEMENT_DELETE_MODAL_TITLE = "si.management.sl.listManagement.modal.title";
export const SL_LIST_MANAGEMENT_DELETE_MODAL_TEXT = "si.management.sl.listManagement.modal.bodyText";
export const SL_LIST_MANAGEMENT_DELETE_MODAL_BTN_CONFIRM = "si.common.button.delete";

export const MANAGEMENT_SF_DISCONNECT_MODAL_DESCRIPTION = "si.management.sf.section.disconnect.modal.description";
export const MANAGEMENT_DISCONNECT_MODAL_TITLE = "si.management.section.disconnect.modal.title";

// SuppressionListManagement
export const SL_MANAGEMENT_FILE_BTN_TEXT_REPLACE = "si.management.sl.listManagement.btn.text.replace";
export const SL_LIST_MANAGEMENT_DELETE_TOOLTIP = "si.management.sl.listManagement.btn.delete.tooltip";
